import { nextTick } from 'vue'
import { createI18n } from 'vue-i18n'
import translation from './translation'

let i18n

export const SUPPORT_LOCALES = translation.supportedLocales()

export function setI18nLanguage (locale) {
  loadLocaleMessages(locale)

  if (i18n.mode === 'legacy') {
    i18n.global.locale = locale
  } else {
    i18n.global.locale.value = locale
  }
}


export async function loadLocaleMessages (locale) {
  // load locale messages with dynamic import
  // const messages = await import(`./${ locale }.json`);
  const messages = await import('./' + locale + '.json')
  // set locale and locale message
  i18n.global.setLocaleMessage(locale, messages.default)
  return nextTick()
}

export default function setupI18n () {
  if (!i18n) {
    const locale = process.env.VUE_APP_DEFAULT_LOCALE
    // These warning messages are only warned in development mode (process.env.NODE_ENV !== 'production') by default, not for production.
    i18n = createI18n({
      locale,
      fallbackLocale: process.env.VUE_APP_FALLBACK_LOCALE,
      warnHtmlInMessage: 'off',
      silentTranslationWarn: true,
      fallbackWarn: false,
      silentFallbackWarn: true,
      fallbackWarn: false
    })

    setI18nLanguage(locale)
  }
  return i18n
}
